import { render, staticRenderFns } from "./BinCollectionScheduleDownload.vue?vue&type=template&id=39100d2f&"
import script from "./BinCollectionScheduleDownload.vue?vue&type=script&lang=js&"
export * from "./BinCollectionScheduleDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports